<template>
  <div class="p-4 bg-gray-600 rounded-l-md">
    <nuxt-link to="/administracao" class="space-x-2">
      <Icon name="pepicons-print:gear-circle" size="32" color="white" />
      <span class="text-white font-semibold">Administração</span>
    </nuxt-link>
  </div>
</template>

<script setup>
</script>

<style lang="scss" scoped></style>
